/**
 * Parses the output of a Cloudflare trace into a record.
 *
 * @param response The output from the Cloudflare trace.
 * @return A record of string keys and values.
 */
export const parseTraceResults = (response: string | undefined): Record<string, string> => {
  const trace: Record<string, string> = {};
  if (!response) return trace;

  response.split('\n')
    .map(line => line.split('='))
    .filter(pair => pair.length == 2)
    .forEach(pair => trace[pair[0]] = pair[1]);

  return trace;
};
